import styled, { keyframes, css } from 'styled-components';
import { themeGet, themeGetColor } from '../../../foundation/theme/themeGet/get.js';
import { Box } from '../../../foundation/Box/index.js';
import { Typography } from '../../../foundation/Typography/styled.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var BOTTOM_SPACING = themeGet('spacing.md');
var Container = styled(Box).withConfig({
  displayName: "Container",
  componentId: "sc-1pngt5f-0"
})(["position:fixed;left:50%;bottom:0;align-items:center;transform:translate(-50%,0);"]);
function getTransitionCSS(state) {
  switch (state) {
    case 'visible':
      return css(["transform:translate(0,0);"]);
    case 'entering':
    case 'leaving':
    case 'hidden':
      return css(["transform:translate(0,calc(100% + ", "));"], BOTTOM_SPACING);
    default:
      return undefined;
  }
}
var Title = styled(Typography).withConfig({
  displayName: "Title",
  componentId: "sc-1pngt5f-1"
})([""]);
var Message = styled(Typography).withConfig({
  displayName: "Message",
  componentId: "sc-1pngt5f-2"
})([""]);
function getAppearanceCSS(appearance) {
  switch (appearance) {
    case 'success':
      return css(["", "{color:", ";}"], Title, themeGetColor('green.400'));
    case 'danger':
      return css(["", "{color:", ";}"], Title, themeGetColor('red.400'));
    case 'info':
    default:
      return css(["", "{color:", ";}"], Title, themeGetColor('gray.0'));
  }
}
var backgroundBlurAnimation = keyframes(["0%{backdrop-filter:blur(0);}100%{background-color:", ";backdrop-filter:blur(", ");}"], themeGetColor('brandPrimary.1000', 0.93), pxToRem(20));
var background = css(["background-color:", ";animation-name:", ";animation-duration:0.2s;animation-fill-mode:forwards;animation-delay:0.2s;"], themeGetColor('brandPrimary.1000'), backgroundBlurAnimation);
var ToastContainer = styled.div.withConfig({
  displayName: "ToastContainer",
  componentId: "sc-1pngt5f-3"
})(["display:flex;position:fixed;flex-direction:column;bottom:", ";gap:", ";min-width:0;width:", ";padding:", ";", ";", ";", ";transition:all 0.2s ease-in-out;box-shadow:", ",", ";border-radius:", ";", "{color:", ";}"], BOTTOM_SPACING, themeGet('spacing.lg'), pxToRem(500), themeGet('spacing.xl'), background, function (props) {
  return getTransitionCSS(props.$transitionState);
}, function (props) {
  return getAppearanceCSS(props.$appearance);
}, themeGet('dropShadow.300'), themeGet('dropShadow.400'), themeGet('borderRadius.md'), Message, themeGetColor('gray.100'));

export { Container, Message, Title, ToastContainer };
